import React from 'react';
import {useSelector} from "react-redux";
import {get} from 'lodash';

import './constellation.scss';
import OneStar from './OneStar';

export default function ({skills_level_data, selectSkill}) {
    const me = useSelector(state => state.me);

    const render_avatar = () => {
        const avatar_class = get(me, 'avatar', '');
        return (
            <div className="constellation-avatar flex-row flex-vh-center">
                <div className={`cashtivity-icon ${avatar_class}`}/>
            </div>
        );
    }

    const render_stars = skills_level_data.map((skill) => {
        return (
            <OneStar
                key={skill.code}
                skill_data={skill}
                selectSkill={selectSkill}
            />
        );
    });

    return (
        <div className="ssp-section overflow-x-auto">
            <div className="constellation">
                <svg viewBox="-200 -200 400 400">
                    <line x1="0" y1="0" x2="0.1" y2="-100" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="55" y2="-100" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="100" y2="-65" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="120" y2="-10" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="100" y2="40" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="70" y2="80" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="30" y2="130" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="-30" y2="130" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="-70" y2="80" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="-100" y2="40" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="-120" y2="-10" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="-100" y2="-65" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <line x1="0" y1="0" x2="-55" y2="-100" stroke="url(#lineGradient)" strokeWidth="1" opacity="0.3"></line>
                    <defs>
                        <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor="hsl(270 70% 60%)"></stop>
                            <stop offset="100%" stopColor="hsl(200 80% 50%)"></stop>
                        </linearGradient>
                    </defs>
                </svg>

                <div className="constellation-title">
                    {`Your Skills Constellation`}
                </div>

                {render_avatar()}

                {render_stars}
            </div>

            <div className="center-align">
                {`Click on any skill star to see more details.`}
            </div>
        </div>
    );
}